import {
  ProgressionModel,
  ProgressionModelServer,
} from 'features/wildfires/wildfire.types';

export const parseProgressionModelServer = (
  modelServer: ProgressionModelServer,
): ProgressionModel => {
  return {
    ...modelServer,
    sourceReferenceTimeZero: new Date(modelServer.sourceReferenceTimeZero),
    sourceReferenceTimeEnd: new Date(modelServer.sourceReferenceTimeEnd),
    dateCreated: new Date(modelServer.dateCreated),
    dateModified: new Date(modelServer.dateModified),
  };
};
